import { motion } from "framer-motion";
import { Phone, Instagram } from "lucide-react";
import { waLink, telLink, SITE } from "@/data/site";
import { WhatsAppIcon } from "@/components/site/BookingButtons";

const INSTAGRAM_GRADIENT =
  "linear-gradient(45deg,#feda75 0%,#fa7e1e 25%,#d62976 50%,#962fbf 75%,#4f5bd5 100%)";

const items = [
  { key: "whatsapp", href: waLink(), label: "Book on WhatsApp", style: { backgroundColor: "#1f8a4c" }, icon: <WhatsAppIcon className="h-6 w-6 md:h-7 md:w-7" />, external: true, testid: "floating-whatsapp" },
  { key: "phone", href: telLink, label: "Call us", style: { backgroundColor: "#1A3626" }, icon: <Phone className="h-5 w-5 md:h-6 md:w-6" fill="currentColor" />, external: false, testid: "floating-call" },
  { key: "instagram", href: SITE.instagram, label: "Instagram", style: { backgroundImage: INSTAGRAM_GRADIENT }, icon: <Instagram className="h-6 w-6 md:h-7 md:w-7" />, external: true, testid: "floating-instagram" },
];

export default function FloatingContacts() {
  return (
    <div className="fixed bottom-5 right-5 z-[65] flex flex-col items-center gap-3">
      {items.map((it, i) => (
        <motion.a
          key={it.key}
          href={it.href}
          aria-label={it.label}
          data-testid={it.testid}
          style={it.style}
          {...(it.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          initial={{ opacity: 0, scale: 0.5, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ delay: 0.6 + i * 0.12, duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          whileHover={{ scale: 1.08 }}
          className="flex h-12 w-12 items-center justify-center rounded-full text-white shadow-[0_8px_24px_rgba(0,0,0,0.28)] ring-1 ring-white/20 md:h-14 md:w-14"
        >
          {it.icon}
        </motion.a>
      ))}
    </div>
  );
}
